import { render, staticRenderFns } from "./HistoryContents.vue?vue&type=template&id=1a691e3a&scoped=true&"
import script from "./HistoryContents.vue?vue&type=script&lang=js&"
export * from "./HistoryContents.vue?vue&type=script&lang=js&"
import style0 from "./HistoryContents.vue?vue&type=style&index=0&id=1a691e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a691e3a",
  null
  
)

export default component.exports